import { XML_AdjustLineWidth } from "./XML_AdjustLineWidth";
import { XML_DrawLinePPT } from "./XML_DrawLinePPT";
import { XML_DrawLinePDF } from "./XML_DrawLinePDF";
import { enumXMLType } from "../constants";

export function XML_DrawLine(x1, y1, x2, y2, lineColor, thickness, dashed, drawElement, layer) {
  var docType = drawElement.GetDocType();
  thickness = XML_AdjustLineWidth(thickness, drawElement, layer);

  if (docType == enumXMLType.PDF) {
    XML_DrawLinePDF(x1, y1, x2, y2, lineColor, thickness, dashed, drawElement, layer);
  } else {
    XML_DrawLinePPT(x1, y1, x2, y2, lineColor, thickness, dashed, drawElement, layer);
  }
}
